/** Search engines cut titles at ~60 characters and descriptions at ~160. */
export const TITLE_MAX = 60
export const DESCRIPTION_MAX = 160

/** The first candidate that fits `max`; the last one if none fits. */
export function firstThatFits(candidates: string[], max = TITLE_MAX): string {
  return candidates.find((c) => c.length <= max) ?? candidates[candidates.length - 1]
}

/** Shorten text to `max` characters: keep whole sentences when possible, else cut at a word. */
export function clampDescription(text: string, max = DESCRIPTION_MAX): string {
  if (text.length <= max) return text
  const sentences = text.match(/[^.!?]+[.!?]+(\s|$)/g) ?? []
  let out = ''
  for (const s of sentences) {
    if ((out + s).trimEnd().length > max) break
    out += s
  }
  // A description under about 110 characters is too short for a search result.
  if (out.trim().length >= 110) return out.trim()
  const cut = text.slice(0, max - 1)
  return `${cut.slice(0, cut.lastIndexOf(' '))}…`
}

/** The absolute og:url for a route path. Child routes that set their own og:url win over it. */
export function ogUrlForPath(pathname: string): string {
  return `https://uptrack.app${pathname.replace(/\/+$/, '')}`
}
